import { render, staticRenderFns } from "./SplitStatusMenu.vue?vue&type=template&id=66fa2bba&scoped=true&"
import script from "./SplitStatusMenu.vue?vue&type=script&lang=js&"
export * from "./SplitStatusMenu.vue?vue&type=script&lang=js&"
import style0 from "./SplitStatusMenu.vue?vue&type=style&index=0&id=66fa2bba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fa2bba",
  null
  
)

export default component.exports